












































































import { Component, Prop } from 'vue-property-decorator'
import { mapState } from 'vuex'

// Mixins
import MatchMixin from '@/mixins/match'

@Component({
  computed: {
    ...mapState('match', ['match']),
  },
})
export default class GameClockAdjustmentButtons extends MatchMixin {
  @Prop() readonly time!: number
  @Prop() readonly durationOfCurrentPeriod!: number

  adjustClock(val: number): void {
    this.$emit('adjust-clock', val)
  }
}
